<template>
  <div class="home-page container-md">
    <h2>Loader 加载中</h2>
    <p>用于页面和区块的加载中状态。</p>

    <h4>何时使用</h4>
    <p>页面局部处于等待异步数据或正在渲染过程时，合适的加载动效会有效缓解用户的焦虑。</p>

    <h4>演示</h4>
    <button class="btn btn-primary btn-large" @click.prevent="isShow = true">点击显示</button>
    <loader v-if="isShow">
      <button class="btn btn-primary btn-large d-block" @click.prevent="isShow = false">点击隐藏</button>
    </loader>
    <h4 class="mt-4">代码</h4>
    <pre class="language-html">
      <code v-html="highlightedCode"></code>
    </pre>
    <h4>Loader 属性和事件</h4>
    <props-table :props="props"></props-table>
  </div>
</template>

<script>
import Prism from 'prismjs'
import Loader from '../components/Loader.vue'
import PropsTable from '../components/PropsTable.vue'
export default {
  data () {
    return {
      isShow: false,
      props: [
        { name: 'text', type: 'string', desc: '额外的文本' },
        { name: 'background', type: 'string', desc: '背景颜色' }
      ],
      code: `
    <button class="btn btn-primary btn-large" @click.prevent="isShow = true">点击显示</button>
    <loader v-if="isShow">
      <button class="btn btn-primary btn-large d-block" @click.prevent="isShow = false">
        点击隐藏
      </button>
    </loader>`
    }
  },
  computed: {
    highlightedCode () {
      return Prism.highlight(this.code, Prism.languages.html)
    }
  },
  components: {
    Loader,
    PropsTable
  }
}
</script>
